module.exports = __webpack_public_path__ + "static/eatbitterfront-80f42c743cbefbe8edf7876557a40f83.jpg";